import React, { useEffect, useRef, useState } from "react";
import {
    ContentState,
    EditorState,
    RichUtils,
    convertFromHTML,
    convertToRaw,
} from "draft-js";
import draftToHtml from 'draftjs-to-html'
import "./index.css";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import OpenAI from "../OpenAI";

const DraftEditor = ({ onChange, state, category }) => {
    const [editorState, setEditorState] = useState(
        EditorState.createEmpty()
    )

    const [showPopup, setShowPopup] = useState(false);


    useEffect(() => {
        if (state) {
            const blocksFromHTML = convertFromHTML(state);
            const contentState = ContentState.createFromBlockArray(
                blocksFromHTML.contentBlocks,
                blocksFromHTML.entityMap,
            );
            setEditorState(EditorState.createWithContent(contentState));
        }
    }, [state])


    const isEmptyListBlock = () => {

        // If the user changes block type before entering any text, we can hide the placeholder
        var contentState = editorState.getCurrentContent();
        if (!contentState.hasText()) {
            if (contentState.getBlockMap().first().getType() !== 'unstyled') {
                return true;
            }
        }
        return false;
    }

    const handleChatGPT = () => {
        setShowPopup(true);
    };

    const handleClose = () => {
        setShowPopup(false);
    };

    const handleAccept = (response) => {
        const blocksFromHTML = convertFromHTML(response);
        const contentState = ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap,
        );
        setEditorState(EditorState.createWithContent(contentState));
        onChange(draftToHtml(convertToRaw(contentState)))
        setShowPopup(false);
    }



    return (
        <div className="editor-wrapper" onKeyDown={(e) => {
            console.log("key press event", e.key)
            if (e.key === "Backspace") {
                if (isEmptyListBlock()) {
                    console.log("empty list block")
                    const newState = RichUtils.toggleBlockType(editorState);

                    if (newState) {
                        console.log(newState)
                        setEditorState(EditorState.moveFocusToEnd(EditorState.createEmpty()));
                    }
                }
            }
        }}>
            <div>
                <div className="btn-chatgpt" onClick={handleChatGPT}>AI Assistant</div>
                {showPopup && <OpenAI category={category} onDismiss={handleClose} onAccept={handleAccept}/>}
            </div>
            <Editor
                editorState={editorState}

                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                onEditorStateChange={(editorState) => {
                    setEditorState(editorState);
                    onChange(draftToHtml(convertToRaw(editorState.getCurrentContent())))
                }}
                placeholder="Write something..."
                toolbar={{
                    options: ['inline', 'list'],
                    inline: {
                        options: ['bold', 'italic', 'underline'],
                    },
                    blockType: {
                        className: 'bordered-option-classname',
                    },
                    list: {
                        options: ['unordered', 'ordered'],
                    },
                    fontSize: {
                        className: 'bordered-option-classname',
                    },
                }}
            />
        </div>
    );
};

export default DraftEditor;
